import "./utilities_namespace.js";
import "./manipulate_input/input_element.js";
import "./manipulate_input/checkbox.js";
import "./manipulate_input/radio.js";
import "./get_input.js";
import { isValueInput } from "#/shared/legacy/forms/manipulate-input.js";

window.Sparkle ??= {};
window.Sparkle.Utilities ??= {};

window.Sparkle.Utilities.setInputValue = function (input, value) {
  input = jQuery(input);
  input.each(function (i, inputItem) {
    inputItem = jQuery(inputItem);

    if (inputItem.is(":checkbox")) {
      new ManipulateCheckbox(inputItem).setValue(value);
    } else if (inputItem.is(":radio")) {
      new ManipulateRadio(inputItem).setValue(value);
    } else if (isValueInput(inputItem[0])) {
      new ManipulateInputElement(inputItem).setValue(value);
    } else {
      inputItem.val(value);
    }
  });
};
